export const EVENT_DETAILS_SCHEMA_URL = 'https://withjoy.com/assets/public/schemas/eventDetailsSchemaV1_0_3.json' as const;
export const EVENT_DETAILS_COMPONENT_TYPE = 'EventDetails' as const;
